module.exports = __webpack_public_path__ + "img/empty-nutritionists.98958624.svg";